import React from 'react';

import { Button } from '@chakra-ui/react';

import { OptionProps } from '../types';

const Option = (props: OptionProps) => {
  const { onClick, children, disabled, selected, isFocused } = props;

  return (
    <Button
      rounded="none"
      w="100%"
      variant="secondary"
      justifyContent="flex-start"
      fontWeight={400}
      onClick={onClick}
      sx={{
        pointerEvents: disabled ? 'none' : 'all',
        borderWidth: '0 0 1px 0',
        '&:last-of-type': {
          borderWidth: 0,
        },
        '&:first-of-type': {
          marginTop: 5,
        },
        whiteSpace: 'normal',
        textAlign: 'left',
        pl: '4',
        backgroundColor: isFocused ? 'grey.100' : 'transparent',
        _focus: {
          backgroundColor: 'grey.100',
        },
      }}
      isActive={selected}
    >
      {children}
    </Button>
  );
};

export { Option };
